import styled from 'styled-components';
import { mediaQueries } from '../../constants/breakpoints';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 24px 20px;
  background: #fff;
  border-radius: 6px;
  @media ${mediaQueries.desktop} {
    margin: 24px 80px;
  }
`;

export const Title = styled.div`
  font-size: 32px;
  font-weight: bold;
  margin: 20px 20px 0;
`;

export const Actions = styled.div`
  display: flex;
  margin: 20px 20px 0;
  flex-direction: column;
  @media ${mediaQueries.desktop} {
    flex-direction: row;
  }
`;

export const SearchInputContainer = styled.div`
  border: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 4px;
  flex: 1;
  display: flex;
  margin-bottom: 10px;
  transition: border-color 0.2s ease;
  &:focus-within {
    border-color: #1976d2;
  }
  @media ${mediaQueries.desktop} {
    margin-right: 10px;
    margin-bottom: 0;
    max-width: 300px;
  }
`;

export const Input = styled.input`
  flex: 1;
  border: none;
  background: transparent;
  outline: none;
`;

export const AlertContainer = styled.div`
  margin-top: 10px;
`;

export const PopupLayer = styled.div`
  font-weight: bold;
  margin: 20px auto;
  width: 100%;
  text-align: center;
`;
